jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$(".hamburger").on("click", function () {
  $(".hamburger").addClass("inactive");
  $(".close-menu").addClass("is-active");
  $(".navigation-wrapper").addClass("navi-open");
  $("body").addClass("navi-open");
});

$(".close-menu").on("click", function () {
  $(".hamburger").removeClass("inactive");
  $(".close-menu").removeClass("is-active");
  $(".navigation-wrapper").removeClass("navi-open");
  $("body").removeClass("navi-open");
});

$(document).on("click", ".js-content-expand-toggle", function () {
  var $toggle = $(this);
  var targetId = $(this).attr("data-expand-target");

  if (!targetId) {
    return;
  }

  var $content = $("#" + targetId);

  if ($content.length === 0) {
    return;
  }

  var isExpanded = !$content.hasClass("is-expanded");
  $content.toggleClass("is-expanded", isExpanded);
  $toggle.attr("aria-expanded", isExpanded ? "true" : "false");
  $toggle.toggleClass("collapsed", !isExpanded);

  var moreLabel = $toggle.attr("data-label-more");
  var lessLabel = $toggle.attr("data-label-less");
  if (moreLabel && lessLabel) {
    $toggle.text(isExpanded ? lessLabel : moreLabel);
  }
});

if (!window.__hoverOpenStripInitialized) {
  window.__hoverOpenStripInitialized = true;

  function initHoverOpenStrip(containerSelector, itemSelector) {
    var desktopMq = window.matchMedia("(min-width: 768px)");
    var blocks = document.querySelectorAll(containerSelector);

    blocks.forEach(function (container) {
      var items = Array.prototype.slice.call(
        container.querySelectorAll(itemSelector)
      );
      if (items.length === 0) {
        return;
      }

      var defaultIndex = items.length > 1 ? 1 : 0;

      function setOpen(index) {
        items.forEach(function (item, itemIndex) {
          item.classList.toggle("is-open", itemIndex === index);
        });
      }

      if (!desktopMq.matches || items.length < 3) {
        setOpen(-1);
        return;
      }

      setOpen(defaultIndex);

      items.forEach(function (item, itemIndex) {
        item.addEventListener("mouseenter", function () {
          setOpen(itemIndex);
        });
      });

      container.addEventListener("mouseleave", function () {
        setOpen(defaultIndex);
      });
    });
  }

  initHoverOpenStrip(".content-three-images .row", "img");
  initHoverOpenStrip(".gallery.js-hover-open-strip", ".js-hover-open-item");
}

function updateHeaderScrollState() {
  var $header = $(".header-container");
  var shouldBeScrolled = $(window).scrollTop() > 0;

  if ($header.hasClass("scrolled") === shouldBeScrolled) {
    return;
  }

  $header.toggleClass("scrolled", shouldBeScrolled);
}

$(window).on("scroll", updateHeaderScrollState);
updateHeaderScrollState();
